<div fxLayout="row" fxLayoutWrap="wrap">
  <div fxFlex.gt-sm="100%" fxFlex="100">
    <mat-card>
      <mat-card-content>
        <mat-card-title>Imposta la password</mat-card-title>
        <mat-card-subtitle>Tramite questa procedura è possibile impostare la password per accedere alla nuova piattaforma</mat-card-subtitle>
      </mat-card-content>

      <mat-card-content>

        <form [formGroup]="frmInserimento">

          <div fxLayout="row" fxLayoutWrap="wrap">
            <div fxFlex.gt-sm="100%" fxFlex="100">
                <mat-form-field class="full-width">
                  <input matInput type="text"
                         placeholder="Codice Fiscale" formControlName="CodiceFiscale" id="CodiceFiscale" />
                </mat-form-field>
</div>
          </div>

          <div fxLayout="row" fxLayoutWrap="wrap">
            <div fxFlex.gt-sm="50%" fxFlex="100">
              <mat-form-field class="full-width">
                <input matInput type="password"
                       placeholder="Password" formControlName="Password" required
                       id="Password" />
              </mat-form-field>
              <div *ngIf="frmInserimento.controls.Password.touched && frmInserimento.controls.Password.invalid" class="text text-danger">
                <div *ngIf="frmInserimento.controls.Password.invalid">
                  <span>Per rendere la password più sicura:</span><br />
                  <span>- dovrebbe essere almeno di 6 caratteri.</span><br />
                  <span>- dovrebbe avere una lettera minuscola.</span><br />
                  <span>- dovrebbe avere una lettera maiuscola.</span><br />
                  <span>- dovrebbe avere un numero.</span><br />
                  <span>- dovrebbe avere un carattere speciale.</span>
                </div>
              </div>
            </div>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div fxFlex.gt-sm="50%" fxFlex="100">
              <mat-form-field class="full-width">
                <input matInput type="password"
                       placeholder="Conferma password" formControlName="ConfermaPassword" required
                       id="ConfermaPassword" />
              </mat-form-field>
              <div *ngIf="frmInserimento.controls.ConfermaPassword.touched && frmInserimento.controls.ConfermaPassword.invalid" class="text text-danger">
                <div *ngIf="frmInserimento.controls.ConfermaPassword.errors.invalid">
                  <span>Per rendere la password più sicura:</span><br />
                  <span>- dovrebbe essere almeno di 6 caratteri.</span><br />
                  <span>- dovrebbe avere una lettera minuscola.</span><br />
                  <span>- dovrebbe avere una lettera maiuscola.</span><br />
                  <span>- dovrebbe avere un numero.</span><br />
                  <span>- dovrebbe avere un carattere speciale.</span>
                </div>
                <div *ngIf="frmInserimento.controls.ConfermaPassword.errors.confirmedValidator">Password e Conferma password non corrispondono.</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div fxFlex="100%;" fxFlex.xs="100%">
              <button mat-raised-button color="accent" (click)="btnSalva()"
                      >
                Salva
              </button>
            </div>
          </div>



        </form>
      </mat-card-content> 

    </mat-card>
  </div>
</div>


